import { render, staticRenderFns } from "./storehouseCallPoliceLog.vue?vue&type=template&id=31f8b601&scoped=true"
import script from "./storehouseCallPoliceLog.vue?vue&type=script&lang=ts"
export * from "./storehouseCallPoliceLog.vue?vue&type=script&lang=ts"
import style0 from "./storehouseCallPoliceLog.vue?vue&type=style&index=0&id=31f8b601&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f8b601",
  null
  
)

export default component.exports